<template>
    <div id="histroy">
        <ul>
            <li v-for="(historyItem,index) in historyItems" :key="index">
                <a :href="historyItem.url">
                    <img :src="'images/' + historyItem.code +'.jpg'" :name="historyItem.name" v-lazy="'images/' + historyItem.code +'.jpg'">
                    <div class="img_remind clearfix"><span>活动已结束！</span>
                        <p><span>{{historyItem.pageView?historyItem.pageView:0}}</span><img src="../assets/images/heart_03.png"></p>
                    </div>
                </a>
                <!--{{historyItem.title}}-->
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'histroy',
        data() {
            return {
                historyItems: []
            }
        },
        mounted() {
            this.addListPast()
        },
        methods: {
            /*历史活动*/
            addListPast() {
                let _this = this

                this.$http.post('/campaign/listPast.ctrl', {
                        headers: {
                            'content-type': 'application/json'
                        }
                    })
                    .then(function (res) {
                        _this.historyItems = res.data.object

                    })
                    .catch(function (err) {
                        console.log(err)
                    })
            },
            /*加载更多*/
            loadMore() {
                let newAry = [];
                for (let i = 0; i < 10; i++) {
                    newAry.push({
                        title: 'hello world'
                    })
                }
                this.historyItems = newAry;
            }
        },
        directives: {
            scroll: {
                bind(el, binding) {
                    window.addEventListener('scroll', () => {
                        if (document.body.scrollTop + window.innerHeight >= el.clientHeight) {
                            let fnc = binding.value;
                            fnc();
                        }
                    })
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// History.vue?037d659e